import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import { Modal, ModalBody, ModalFooter } from "components";
import useTranslation from "hooks/useTranslation";
import useModal from "hooks/useModal";
import styles from "./styles.module.scss";
import clsx from "clsx";

// When user hits 'close' button then message will not be shown untill next login and by filling 'checkbox' it will never be shown again.
// NOTE: call 'changePopupMsgStatusByLogout' function when log-outing to change popup's showing status.
function PopupMessage({
  closeBtnText,
  neverShowCheckboxText,
  popupName,
  content,
  onClose,
}) {
  const [visible, , hideModal, showModal] = useModal();
  const [notShowPopupAgain, setNotShowPopupAgain] = useState(false);

  const { getTranslation } = useTranslation("COMMON");
  const { t } = getTranslation();

  const renderCloseBtnText = closeBtnText || t("POPUP_MESSAGE").CLOSE_DEFAULT;
  const renderNeverShowMsg =
    neverShowCheckboxText || t("POPUP_MESSAGE").NEVER_SHOW_DEFAULT;

  const getShowPopupStatus = () => {
    const status = localStorage.getItem(popupName);
    return !["never", "nextLogin"].includes(status);
  };

  const handleChangePopupDisplay = () => {
    setNotShowPopupAgain((prev) => !prev);
  };

  const handleClosePopup = () => {
    const status = notShowPopupAgain ? "never" : "nextLogin";

    localStorage.setItem(popupName, status);
    hideModal();
    onClose && onClose();
  };

  const renderPopupBody = (
    <>
      {/* content heading */}
      {/* <div className={styles.modal_heading}>
        <span onClick={handleClosePopup} className={styles.close_popup}>
          <img src={CloseModal} alt="" />
        </span>
      </div> */}

      {/* content body */}
      <div className={styles.popup__body}>{content}</div>

      <br />

      {/* content footer */}
      <div>
        <input
          type="checkbox"
          checked={notShowPopupAgain}
          onChange={handleChangePopupDisplay}
          id="text"
        />
        <label aria-labelledby="label" htmlFor="text">
          {renderNeverShowMsg}
        </label>
      </div>
    </>
  );

  useEffect(() => {
    if (getShowPopupStatus()) {
      showModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal className={styles.popup} visible={visible}>
      <ModalBody>{renderPopupBody}</ModalBody>
      <ModalFooter>
        <div
          className={clsx([styles.footer, "modal__container__footer__left"])}
        >
          <a
            href="#/"
            onClick={handleClosePopup}
            className="btn btn-primary"
            id="closeModal"
          >
            {renderCloseBtnText}
          </a>
        </div>
      </ModalFooter>
    </Modal>
  );
}

PopupMessage.propTypes = {
  closeBtnText: PropTypes.string,
  neverShowCheckboxText: PropTypes.string,
  popupName: PropTypes.string.isRequired,
  content: PropTypes.node,
};

export default PopupMessage;
